export const defaultConfig = {
  "connector.class": "org.apache.kafka.connect.tools.MockConnector",
  "name": "Test",
  "transforms": "insertCreatedDate,renameFields,selectFields",
  "transforms.renameFields.type": "org.apache.kafka.connect.transforms.ReplaceField$Value",
  "transforms.renameFields.renames": "Id:PersonId, ModifiedBy:CreatedBy",
  "transforms.selectFields.type": "org.apache.kafka.connect.transforms.ReplaceField$Value",
  "transforms.selectFields.whitelist": "PersonId,CreatedBy,CreatedOn",
  "transforms.insertCreatedDate.type": "org.apache.kafka.connect.transforms.InsertField$Value",
  "transforms.insertCreatedDate.timestamp.field": "CreatedOn"
}
